import React, { useEffect, useState } from "react";
import useTableR from "../../useTableR";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import { formatMoneda } from "../../../util/varios";
import axios from "axios";

export default function TablaProveedores(props) {
  const token = localStorage.getItem("jwtToken");
  const op = require("../../../modulos/datos");
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    {
      id: "1",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "2",
      label: "NOMBRE",
      width: "80px",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "3",
      label: "MONTO",
      width: "80px",
      textAlign: "right",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "4",
      label: "OPCIONES",
      width: "80px",
      textAlign: "right",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableR(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idproveedor.includes(target.value) ||
              x.razonsocial.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const buscarRegistros = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/comprasAlmacen/proveedoresCompras?idFiscal=${props.idFiscal}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        setRecords(response.data);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar los Registros de las Tablas",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const imprimirReporte = (idProveedor) => {
    try {
      if (!idProveedor) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "No se ha Seleccionado Ningún Proveedor",
          icono: "error",
        });
        return;
      }
      window.open(
        op.reportes +
          "/comprasyalmacen?" +
          "reporte=ProveedoresProductosCompras" +
          `&efiscal=${props.idFiscal}` +
          `&CONDICION=O.idproveedor = ${idProveedor}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };
  useEffect(() => {
    buscarRegistros();
  }, [props.idFiscal]);
  return (
    <div>
      <div className="col-12 m-0 p-0 d-flex justify-content-between row">
        <header className="col-12 azulGradiant py-2 d-flex align-items-center justify-content-between text-light border-bottom">
          <h3 className="fw-bold text-light m-0">Lista de Proveedores</h3>
        </header>
        <div className="col-5 input-group input-group-sm m-1 p-1 mr-auto">
          <input
            type="text"
            onChange={handleSearch}
            className="form-control rounded-pill search-input"
            placeholder="Buscar..."
          />
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index}>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", width: "10px" }}
                  >
                    {item.idproveedor}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "left", width: "auto" }}
                  >
                    {item.razonsocial}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "right", width: "auto" }}
                  >
                    {formatMoneda(
                      (item.monto || 0).toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", width: "10px" }}
                  >
                    <button
                      className={"btn btn-sm btn-info rounded-pill"}
                      onClick={() => imprimirReporte(item.idproveedor)}
                    >
                      <i className="fa fa-print"></i>
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <Dimmer active={loading} inverted />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
    </div>
  );
}
